<template>
	<!--	:name="vpEtikett"-->
	<!-- '#default' nedan = 'v-slot:default' = nya sättet att sätta 'slot-scope' och kallas 'slot props' (slotProps): -->
	<validation-provider ref="validationProvider"
		tag="div"
		mode="eagerMedBlurOchDebounce"
		:rules="vpValidationRules"
		#default="{ valid, errors, failedRules, flags }"
		class="_eui-form_select_validation-provider"
	>
		<div
			class="_eui-form_select"
			:class="[ vpClass, {
				'-obligatorisk':arRequired && !vpIndikeraInteObligatorisk,
				'-readonly':vpReadOnly,
				'-osynlig':skaVaraOsynlig,
				'-invalid':flags.validated && !valid,
			}]"
			:style="vpStyle"
			:disabled="skaVaraInaktiverad"
		>
			<label
				:for="uniktId"
				:title="vpTooltip"
				class="_eui-form_select_etikett"
				:class="{
					fore:true,
					'-readonly':vpReadOnly,
				}"
				:style="{ 'max-width':vpEtikettbreddMedEnhet }"
				v-html="vpEtikett + ':'"
			></label>

			<div class="_eui-form_select_rutyta"
				:style="{ 'max-width':vpRutbreddMedEnhet }"
			>

				<!--
					– VeeValidate: The fields being validated *must have a v-model* so the component can correctly identify the element/component being validated.
					– required är *inte* för validering, utan för att "placeholder" ska visas, se https://codepen.io/tigt/post/placeholder-for-required-selects.

					v-model.trim="innerValue"
				-->
				<select ref="inputelementet"
					:id="uniktId"
					:name="uniktId + '-name'"
					v-model="innerValue"
					:required="!!vpPlaceholder && !vpReadOnly"
					:autofocus="vpAutofocus"
					:disabled="skaVaraInaktiverad || vpReadOnly"
					:class="{
						'-readonly':vpReadOnly,
					}"
					@keydown.enter="onEnterTryckt()"
					@keydown.esc="onEscTryckt()"

					v-bind="$attrs"
					v-on="$listeners"
				>
					<!-- Obs! Specialare som fungerar som "placeholder", se https://codepen.io/tigt/post/placeholder-for-required-selects: -->
					<option v-if="!!vpPlaceholder" value="" disabled v-html="(vpReadOnly ? '' : vpPlaceholder)"></option>

					<option v-for="(alt, altIndex) in vpSelectConfig.alternativ" :key="altIndex"
						:id="altUniktId(altIndex)"
						:disabled="alt.disabled || skaVaraInaktiverad || vpReadOnly"
						:value="alt.varde"
						:selected="innerValue === alt.varde"
						class="_eui-form_select-alt"
						v-html="alt.text + '&nbsp;'"
					></option>

				</select>

	<!--<div class="-rod-text">{{ errors.first('email') }}</div>-->

				<!--<transition name="el-zoom-in-left">-->
					<div class="_eui-form_select_feltext">
						<div class="ellipsis" v-html="errors[0]">
							<!--{{ errors[0] }}-->
						</div>
					</div>
				<!--</transition>-->

			</div>

		</div>
	</validation-provider>
</template>



<script>
//#####################################################################################

	import Vue from 'vue';
	import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
	import { ValidationProvider } from 'vee-validate';
	import euiFormClasses from 'v-components/classes/euiFormClasses';

	import VeeValidateInstanceMedRattOptions from 'VeeValidateInstanceMedRattOptions';
	VeeValidateInstanceMedRattOptions.runOnce();		// Kör funktionen om den inte redan körts!

	// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
	let uniktIdCounter = 0;


	export default {

		name: 'eui-form-select',

		mixins: [ euiLifecycleStatusesMixin ],

		components: {
			'validation-provider': ValidationProvider,
		},

		props:
		{
			// must be included in props
			value: {
				type: null,
			},

			vpSelectConfig: {
				type: [euiFormClasses.selectConfig],
				required: true,
			},

			vpPlaceholder: {
				type: String,
				default: undefined
			},

			vpAutofocus: {
				type: Boolean,
				default: false,
			},

			vpEtikett: {			// Får innehålla HTML.
				type: String,
				default: null,
			},
			vpEtikettbreddMedEnhet: {
				type: String,
				default: '7rem',
			},
			vpRutbreddMedEnhet: {
				type: String,
				default: '22rem',
			},

			vpIndikeraInteObligatorisk: {
				type: Boolean,
				default: false,
			},

			vpValidationRules: {
				type: [Object,String],
				default: '',
			},

			vpAccessKey: {
				type: String,
				default: null
			},
			vpTooltip: {
				type: String,			// Får innehålla HTML.
				default: null
			},

			vpReadOnly: {
				type: Boolean,
				default: false,
			},
			vpInaktiverad: {
				type: Boolean,
				default: false,
			},
			vpOsynlig: {
				type: Boolean,
				default: false,
			},

			vpClass: {
				type: String,
				default: null
			},
			vpStyle: {
				type: String,
				default: null
			},
		},

		data() {
			return {
				uniktId: 'eui-form-select-unikt-' + (++uniktIdCounter),
				innerValue: '',
			};
		},

		inheritAttrs: false,		// Attribut på komponenten ärvs inte till själva *komponentens* rot-element, utan ist till input-elementet, se template ovan. (Gäller *inte* class- och style-attributen!)

		computed: {

			arRequired() {
				return (!this.vpReadOnly && !this.skaVaraInaktiverad && !!this.vpValidationRules && !!(this.vpValidationRules.indexOf('required') !== -1));
			},

			skaVaraOsynlig() {
				return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedHasOccured);
			},
			skaVaraInaktiverad() {
				return (this.vpInaktiverad || !this.lifecycleStatuses.mixinMountedHasOccured);
			},
		},

		watch: {
			// Handles internal model changes.
			innerValue(nyttVarde, tidigareVarde) {
				this.$emit('input', nyttVarde);
			},

			// Handles external model changes.
			value(nyttVarde, tidigareVarde) {
				this.innerValue = nyttVarde;
			},

			vpReadOnly(nyttVarde, tidigareVarde)
			{
				if (!nyttVarde)
				{
					// Om den ändrats från read-only –> ändringsbar:
					// Sätt ev autofocus:
					this.sattEventuellAutofocus();
				}
			},
		},

		methods: {
			altUniktId(index) {
				return this.uniktId + '-alt-' + index;
			},

			onEnterTryckt()
			{
				this.$emit('enter-tryckt');
			},

			onEscTryckt() {
				this.$emit('esc-tryckt');
			},

			sattEventuellAutofocus()
			{
				// Sätt ev autofocus:
				if (this.vpAutofocus)
				{
					// Invänta, så att ev reaktiva ändringar (här, att inputelementet blir fokuserbart) hinner slå igenom först:
					Vue.nextTick(function () {
							this.$refs.inputelementet
								.focus();
						}
						, this	// Vue.nextTick 'this' context.
					);
				}
			},
		},


		//== Lifecycle hooks  ================================================================================================================

		created() {
			if(this.value) {
				this.innerValue = this.value;
			}
		},

		mounted() {

			this.$nextTick(function () {
				// Sätt ev autofocus:
				this.sattEventuellAutofocus();
			});
		},

	}
</script>
